module.exports = __webpack_public_path__ + "static/media/vivo.f26687f6.svg";